import { AfterContentChecked, ChangeDetectorRef, Component, Inject, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-my-product-edit',
  templateUrl: './my-product-edit.component.html',
  styleUrl: './my-product-edit.component.scss'
})
export class MyProductEditComponent implements OnInit, AfterContentChecked {

  constructor(
    @Optional()
    @Inject(MAT_BOTTOM_SHEET_DATA) 
    private passedData: any,
    
    @Optional()
    private activeModal: NgbActiveModal,

    @Optional()
    private activeBottomSheet: MatBottomSheetRef,

    private auth: AuthServiceService,
    private local: LocalServiceService,
    
    private cdr: ChangeDetectorRef,
    private commonService: CommonService
  ){
  }
  ngAfterContentChecked(): void {
    this.checkIfDescritpionOverflows();
  }

  public productData? = null;

  public ngOnInit(){
    this._getProductData();
  }

  public mainPageIndex = 0;
  

  public productVariants = []
  public promos = []

  public descriptionNow = '';
  public candidateDescription = '';

  public imgUrl = environment.ImageUrl;

  public readonly VARIANT_FILE_SELECTOR = 'variantImage';
  public readonly PROMO_FILE_SELECTOR = 'promoImage';


  public promoConvertedImageUrl = null;

  public clickId(id){
    this.commonService.clickButton(id);
  }
  private _imgIndex = 0;
  private attachImageAndConvert(payload: FormData, obj,  {imageApiName='img', 
                                                imageUploadPropName='uploadImage', 
                                               imageConvertedURLPropName='convertedImage',}){
   
    const copy = {...obj}
    let imageAttachName = '';

    if(copy[imageUploadPropName]){
      imageAttachName = imageApiName + this._imgIndex++;
  
      delete copy[imageConvertedURLPropName]
      delete copy[imageUploadPropName]

    }

    payload.append(imageAttachName, obj[imageUploadPropName])
    return {
      ...copy,
      imageAttachName,
    }

  }
  
  public doesDescrHolderOverflow = false;
  public allowDescrHolderOverflow = false;

  private _isDescrHolderOverflowChecked = false;
  private checkIfDescritpionOverflows(){
    const elem = document.getElementById('descrHolder');
    if(!elem){
      return this.doesDescrHolderOverflow;
    }
    if(this._isDescrHolderOverflowChecked){
      return;
    }

     if(this.commonService.linesInElement(elem) > 5){
       this.doesDescrHolderOverflow = true;
     }  
     else{
      this.doesDescrHolderOverflow = false;
     }
     
     this._isDescrHolderOverflowChecked = true;
  }
  public async imageChanged(type, index, event){
    const [convertedFileUrl, fileBlob] = await this.convertImageToURL(event)

    switch(type){
      case 'promo':{
        this.promos[index].uploadImage = fileBlob;
        this.promos[index].convertedImage = convertedFileUrl
        break
      }
      case 'variant':{
        this.productVariants[index].uploadImage = fileBlob;
        this.productVariants[index].convertedImage = convertedFileUrl
        break

      }
      default: {
        throw new Error("Error unknown type: " + type)
      }
    }
    this.cdr.detectChanges();
  }
  
  private _setUpVariants(variants){
     this.productVariants = []
     for(const variant of variants){
      this.productVariants.push(
        {
            id: variant.id,
            name: variant.value,
            price: parseFloat(variant.key) ? parseFloat(variant.key) : 0,
            image: variant.image,
            outOfStockSingle: '',
            costPrice: '',
            nprice: ''
       }
      )
     }
     console.log('variants', this.productVariants)
  }
  public closeModal(){
    this.activeBottomSheet?.dismiss()
    this.activeModal?.dismiss()

  }
 
  private reportError(){
    this.local.alertError({message: 'Something went wrong please  try again latter. And inform the admin using report bug to get points'})
    this.closeModal()
  }
  private _getProductData(){
    this.auth.getShopProductDetails({productId: this.productData?.id ?? this.passedData?.id})
    .subscribe({
      next: data =>{
          this.productData = data.body;
          this._setUpVariants(this.productData?.memberShopProductsVariations);
          this._setUpPromos(this.productData?.productMoreServices)
          this.descriptionNow = this.productData?.description;
      },
      error: err =>{
        console.error(err);
        this.reportError();
       
      }

    })
  }


  private _getVairantJson(payload): string{

    const mappedVariants = this.productVariants.map((i) => {
      let input = i;
      input.price = input?.price ? input?.price.toString() : '';
      input.nprice = input?.nprice || 0;
      input.costPrice = input?.costPrice || 0;
      input.weight = input?.name
      return input;
    }).map(variation => this.attachImageAndConvert(payload, variation, {
      imageApiName: 'variantImage',
    }));
    return JSON.stringify(mappedVariants)

  }
  public addNewVariant(){
    this.productVariants.push({
      name: '',
      price: 0,
      image:null,
      outOfStockSingle: '',
      costPrice: '',
      nprice: ''
    });
    this.cdr.detectChanges()
  }
  public removeVariant(i){
    this.productVariants.splice(i, 1);
    this.cdr.detectChanges()
  }
  
  
  public addNewPromo(){
    this.promos.push({
      serviceComment: '',
      iconText: '',
      referAmount: '',
      allowRefer: '',
      expiryInString: 'Never',
      serviceDescription: '',
    });
    this.cdr.detectChanges()
  }
  public removePromo(i){
    this.promos.splice(i, 1);
    this.cdr.detectChanges()
  }
  private _getPromoJson(payload): string{

    const mappedPromos = this.promos.map(variation => this.attachImageAndConvert(payload, variation, {
      imageApiName: 'promoImage',
    }));
    return JSON.stringify(mappedPromos)

  }
  private _setUpPromos(promos){
     this.promos = promos
  }
  public expiryStringChanged(event, i) {
    const value = event.target?.value;
    this.promos[i].expiryInString = value
  }


  public availableExpiryIntervals = ['1 Week', '1 Month', '2 Month', 'Never']

  private get _isThereAnEmptyPhotoPromo(): boolean{
    return this.promos.some(promo => !promo.uploadImage)
  }
  public submitChanges(){
    
    if(this._isThereAnEmptyPhotoPromo){
      this.local.alertInfo({title: 'Missing image', message: 'Please add an image on all the promo entries'})
      return;
    }
    const payload = new FormData()
    payload.append('name', this.productData?.name);
    payload.append('type', this.productData?.type);

    payload.append('jsonString', this._getVairantJson(payload))
    payload.append('otherServices', this._getPromoJson(payload))
   
    
    if(this.productData?.type == 'promote'){
      payload.append('shoutDescription', this.candidateDescription)
      payload.append('shoutContact', this.productData?.shoutContact)
      payload.append('shoutName', this.productData?.shoutName)
    }
    payload.append('description', this.candidateDescription)

   
    payload.append('productId', this.productData?.id);
    this.auth.editShopProduct(payload).subscribe({
      next: data =>{
        this.local.alertSuccess({message: 'Thank You! Product Data Updated'})
        this.closeModal();
      },
      error: err =>{
        console.error(err);
        this.reportError();
       
      }
    })

  }



  private convertImageToURL(fileEvent, index=0, ) : Promise<any[]>{
    return this.commonService.convertImageToURL(fileEvent, index);
  }


}
